import { ShoppingBag, Leaf } from "lucide-react";
import { motion } from "framer-motion";

export default function Nav({ qty, onBasket, onNav }) {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-[80] backdrop-blur-xl bg-[#052221]/70 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => onNav("top")}
          className="flex items-center gap-2 text-[#F4F1EB]"
        >
          <Leaf className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
          <span className="font-display text-lg tracking-tight">Ubiquinol CoQ10</span>
        </button>

        <nav className="hidden md:flex items-center gap-9 text-xs uppercase tracking-[0.2em] text-[#B8C5C4]">
          <button data-testid="nav-science" onClick={() => onNav("manifesto")} className="hover:text-[#F4F1EB] transition-colors">Science</button>
          <button data-testid="nav-benefits" onClick={() => onNav("benefits")} className="hover:text-[#F4F1EB] transition-colors">Benefits</button>
          <button data-testid="nav-checkout" onClick={() => onNav("checkout")} className="hover:text-[#F4F1EB] transition-colors">Order</button>
        </nav>

        <button
          data-testid="open-basket-btn"
          onClick={onBasket}
          className="relative flex items-center gap-2 px-4 py-2 border border-[#D4AF37]/40 text-[#D4AF37] text-xs uppercase tracking-[0.18em] hover:bg-[#D4AF37] hover:text-[#052221] transition-colors"
        >
          <ShoppingBag className="w-4 h-4" strokeWidth={1.5} />
          <span>Basket</span>
          <span
            data-testid="basket-count"
            className="min-w-[20px] h-5 px-1 flex items-center justify-center bg-[#D4AF37] text-[#052221] text-[11px] font-bold rounded-full"
          >
            {qty}
          </span>
        </button>
      </div>
    </motion.header>
  );
}
